<ng-container *ngIf="category">
  <a *ngIf="!skipParent" [routerLink]="['/browse','category',category?.id]">{{categoryService.getCategoryName(category)}}</a>
  <ul *ngIf="category?.subcategories !== undefined">
    <li *ngFor="let subcategory of categoryService.getSubcategories(category)">
      <app-category-list-item [category]="subcategory"></app-category-list-item>
    </li>
  </ul>
</ng-container>
